const validateChildConcern=(formData)=>
  {
    if (formData.age <= 15 && formData.childConcern)
        {formData.message.childConcern="Take into account the insight and knowledge of parents and carers when considering making a referral for suspected cancer in a child or young person. Consider referral for children if their parent or carer has persistent concern or anxiety about the child's symptoms, even if the symptoms are most likely to have a benign cause."
        formData.twrValid.childConcern = true
        return formData
        }
    }

    export default validateChildConcern